import { hideAndRemove } from "../../changeObjectParams/helpers";
import { cloneObject } from "../../cloneObject";

export default [
    {
        key: "tumba__",
        position: "bottom",
        // extra: function (el) {
        //     const rightTumba = cloneObject(el);
        //     rightTumba.scale.x = -1; // Отзеркаливаем по оси X
        //     rightTumba.name = el.name + "__right"; // Присваиваем имя

        //     const leftKey_R = rightTumba.children.find((item) => item.name.includes("key_left"));
        //     const leftArm_R = rightTumba.children.find((item) => item.name.includes("arm_right"));
        //     hideAndRemove(leftKey_R);
        //     hideAndRemove(leftArm_R);
        //     rightTumba.userData.allFolderName = "allVerstakTumbaRight";
        //     rightTumba.userData.activeFolderName = "activeVerstakTumbaRight";
        //     rightTumba.userData.position = this.position;
        //     rightTumba.userData.isBottom = this.position === "bottom";
        //     servObj.allVerstakTumbaRight.push(rightTumba);
        //     const leftTumba = el;
        //     leftTumba.name = el.name + "__left";
        //     const rightKey_L = leftTumba.children.find((item) => item.name.includes("key_right"));
        //     const rightArm_L = leftTumba.children.find((item) => item.name.includes("arm_left"));
        //     hideAndRemove(rightKey_L);
        //     hideAndRemove(rightArm_L);
        //     leftTumba.userData.allFolderName = "allVerstakTumbaLeft";
        //     leftTumba.userData.activeFolderName = "activeVerstakTumbaLeft";
        //     leftTumba.userData.position = this.position;
        //     leftTumba.userData.isBottom = this.position === "bottom";
        //     servObj.allVerstakTumbaLeft.push(leftTumba);
        // },
        extra: function (el) {
            const leftTumba = cloneObject(el);
            leftTumba.scale.x = -1; // Отзеркаливаем по оси X
            leftTumba.name = el.name + "__left"; // Присваиваем имя

            const leftKey_R = leftTumba.children.find((item) => item.name.includes("key_left"));
            const leftArm_R = leftTumba.children.find((item) => item.name.includes("arm_right"));
            hideAndRemove(leftKey_R);
            hideAndRemove(leftArm_R);

            leftTumba.userData.allFolderName = "allVerstakTumbaLeft";
            leftTumba.userData.activeFolderName = "activeVerstakTumbaLeft";
            leftTumba.userData.position = this.position;
            leftTumba.userData.isBottom = this.position === "bottom";
            servObj.allVerstakTumbaLeft.push(leftTumba);

            const rightTumba = el;
            rightTumba.name = el.name + "__right";

            const rightKey_L = rightTumba.children.find((item) => item.name.includes("key_right"));
            const rightArm_L = rightTumba.children.find((item) => item.name.includes("arm_left"));
            hideAndRemove(rightKey_L);
            hideAndRemove(rightArm_L);

            rightTumba.userData.allFolderName = "allVerstakTumbaRight";
            rightTumba.userData.activeFolderName = "activeVerstakTumbaRight";
            rightTumba.userData.position = this.position;
            rightTumba.userData.isBottom = this.position === "bottom";
            servObj.allVerstakTumbaRight.push(rightTumba);
        },
    },
    {
        key: "opora",
        allArray: "allVerstakOpora",
        activeArray: "activeVerstakOpora",
        position: "bottom",
        extra: (el) => {
            el.name += "__right";
            const leftOpora = cloneObject(el);
            leftOpora.scale.x = -1;
            leftOpora.name = leftOpora.name.replace("__right", "__left");
            servObj.allVerstakOpora.push(leftOpora);
        },
    },
    {
        key: "perekladini",
        allArray: "allVerstakPerekladini",
        activeArray: "activeVerstakPerekladini",
        position: "bottom",
    },
    {
        key: "dopolnitelnoe_pokritie",
        allArray: "allTableCover",
        activeArray: "activeTableCover",
        position: "bottom",
    },
    {
        key: "perfopanel",
        allArray: "allPerfopanel",
        activeArray: "activePerfopanel",
        position: "bottom",
        extra: (el) => {
            const bsize = servObj.building.getBoundaryGeometry(el);
            el.userData.bsize = bsize;
        },
    },
    {
        key: "polka_pri",
        allArray: "allVerstakPolka",
        activeArray: "activeVerstakPolka",
        position: "bottom",
        extra: (el) => {
            if (el.name.includes("odnoy")) {
                el.name += "__right";
                const leftPolka = cloneObject(el);
                leftPolka.scale.x = -1;
                leftPolka.name = leftPolka.name.replace("__right", "__left");
                servObj.allVerstakPolka.push(leftPolka);
            }
        },
    },
    {
        key: "komplekt_stoek",
        allArray: "allKomplektStoek",
        activeArray: "activeKomplektStoek",
        position: "bottom",
    },
    {
        key: "panel_elektromontazhnaya",
        allArray: "allPanelElektromontazhnaya",
        activeArray: "activePanelElektromontazhnaya",
        position: "top",
        extra: (el) => {
            const name = el.name.split("__");
            let rightEl = null;
            const size = name[3];

            if (size < 1200) {
                const newName = `verstak__vs__panel_elektromontazhnaya__left__${size}`;
                el.name = newName;
                el.userData.name = newName;
                rightEl = cloneObject(el);
                rightEl.position.x *= -1;
                rightEl.name = rightEl.name.replace("left", "right");
                rightEl.userData.name = rightEl.name;
            }

            if (rightEl) {
                servObj.allPanelElektromontazhnaya.push(rightEl);
            }
        },
    },
];
